import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {PlusIcon} from '@salesforce/retail-react-app/app/components/icons'
import {pxToRem} from '../../utills/pxToRem'
import colors from '../../theme/foundations/colors'
import {addAddressButtonStyle, headingStyle, textStyle} from './index.style'

const PageActionPlaceHolder = ({heading, text, buttonText, buttonProps, onButtonClick}) => {
    return (
        <Box>
            <Box
                boxShadow={`${pxToRem(2)} ${pxToRem(4)} ${pxToRem(16.6)} ${pxToRem(2)} ${
                    colors.blackAlpha[400]
                }`}
                paddingLeft={[pxToRem(19), pxToRem(19), pxToRem(18), pxToRem(18)]}
                paddingBottom={[pxToRem(15), pxToRem(15), pxToRem(23), pxToRem(23)]}
                paddingTop={[pxToRem(15), pxToRem(15), pxToRem(23), pxToRem(23)]}
                marginTop={[pxToRem(15), pxToRem(15), pxToRem(25), pxToRem(25)]}
                marginBottom={[pxToRem(30), pxToRem(30), pxToRem(180), pxToRem(180)]}
                marginLeft={[pxToRem(11), pxToRem(11), '0px', '0px']}
                marginRight={[pxToRem(11), pxToRem(11), pxToRem(45), pxToRem(45)]}
            >
                <Text sx={headingStyle}>{heading}</Text>
                <Text sx={textStyle}>{text}</Text>
                <Button
                    sx={addAddressButtonStyle}
                    onClick={onButtonClick}
                    leftIcon={<PlusIcon />}
                    {...buttonProps}
                >
                    {buttonText}
                </Button>
            </Box>
        </Box>
    )
}

PageActionPlaceHolder.propTypes = {
    heading: PropTypes.string,
    text: PropTypes.string,
    buttonText: PropTypes.string,
    icon: PropTypes.any,
    buttonProps: PropTypes.object,
    onButtonClick: PropTypes.func
}

export default PageActionPlaceHolder
